import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import DateSearchComponent from "../../components/customTable/DateSearchComponent";

import { Box, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import { ContentCopy, Delete } from "@mui/icons-material"; // Import the copy icon from MUI

import { mfdApi } from "../../app/slices/MFD/mutualFundSlice";

export default function MFD() {
  const dispatch = useDispatch();
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });
  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };
  useEffect(() => {
    dispatch(mfdApi(queryParams));
  }, [dispatch, queryParams]);

  const sliceResponse = useSelector((state) => state.mfd.mfd.data);
  //   console.log("sliceData::::::::::::::::::::", sliceResponse);
  const stateLoading = useSelector((state) => state.mfd.loading);

  // loading={stateLoading}

  const columnHelper = createMRTColumnHelper();

  const columns = [
    columnHelper.accessor("_id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original._id);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original._id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("partner_id", {
      header: "Partner Id",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original.partner_id);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original.partner_id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("employee_id", {
      header: "Employee Id",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original.employee_id);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original.employee_id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("partner_username", {
      header: "Partner Username",
      Cell: (cell) => <div>{cell.row.original.partner_username}</div>,
    }),

    columnHelper.accessor("username", {
      header: "Login Username",
      Cell: (cell) => <div>{cell.row.original.username}</div>,
    }),

    columnHelper.accessor("name", {
      header: "Name",
      Cell: (cell) => <div>{cell.row.original.name}</div>,
    }),

    columnHelper.accessor("Email", {
      header: "Email",
      Cell: (cell) => <div>{cell.row.original.Email}</div>,
    }),

    columnHelper.accessor("PhoneNo", {
      header: "Phone",
      Cell: (cell) => <div>{cell.row.original.PhoneNo}</div>,
    }),

    columnHelper.accessor("panNo", {
      header: "PAN",
      Cell: (cell) => <div>{cell.row.original.panNo}</div>,
    }),

    columnHelper.accessor("dob", {
      header: "DOB",
      Cell: (cell) => <div>{cell.row.original.dob}</div>,
    }),

    columnHelper.accessor("GSTIN", {
      header: "GSTIN",
      Cell: (cell) => <div>{cell.row.original.GSTIN || "N/A"}</div>,
    }),
    columnHelper.accessor("commission", {
      header: "Commission",
      Cell: (cell) => <div>{cell.row.original.commission || "N/A"}</div>,
    }),

    columnHelper.accessor("address", {
      header: "Address",
      Cell: (cell) => <div>{cell.row.original.address}</div>,
    }),

    columnHelper.accessor("state", {
      header: "State",
      Cell: (cell) => <div>{cell.row.original.state}</div>,
    }),

    columnHelper.accessor("city", {
      header: "City",
      Cell: (cell) => <div>{cell.row.original.city}</div>,
    }),

    columnHelper.accessor("pincode", {
      header: "Pincode",
      Cell: (cell) => <div>{cell.row.original.pincode}</div>,
    }),

    columnHelper.accessor("isBlocked", {
      header: "Blocked",
      Cell: (cell) => <div>{cell.row.original.isBlocked ? "Yes" : "No"}</div>,
    }),

    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => cell.row.original.createdAt?.split("T")[0],
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: (cell) => cell.row.original.updatedAt?.split("T")[0],
    }),
  ];

  return (
    <>
     {/*  */}
      {/* {sliceResponse ? ( */}
      <>
        <DateSearchComponent onSearch={handleSearch} />
        <Box mt={{xs:2}} >
          <CustomTable
            columns={columns}
            data={sliceResponse}
            loading={stateLoading}
            permissionKey="mutualFund"
          />
        </Box>
      </>
      {/* ) : (
        <LinearProgress />
      )} */}
    </>
  );
}
